import { useEffect, useState } from "react";
import { getCampaignById, updateCampaign } from "../services/campaign.api";
import CampaignChannelSelector from "../components/CampaignChannelSelector";
import CampaignTargetSelector from "../components/CampaignTargetSelector";
import CampaignScheduleSelector from "../components/CampaignScheduleSelector";
import { useParams } from "react-router-dom";
import { useHistory,useRouteMatch,} from "react-router-dom";
import { useSelector } from "react-redux";
export default function EditCampaignScreen() {
const currentToken = useSelector((state)=>state?.user?.user?.token);
          const appToken = useSelector((state)=>state?.app?.app?.AppToken);
          
         const tenantId = useSelector((state)=>state?.user?.user?.user_id)

  const { id } = useParams();
const {url}=useRouteMatch();
  const history = useHistory();

  const [campaign, setCampaign] = useState(null);

  const [name, setName] = useState("");
  const [channel, setChannel] = useState("push");
  const [targetType, setTargetType] = useState("all");
  const [targetId, setTargetId] = useState(null);
  const [templateUseCase, setTemplateUseCase] = useState("");
  const [scheduledAt, setScheduledAt] = useState(null);

  useEffect(() => {
    fetchCampaign();
  }, []);

  async function fetchCampaign() {
    const res = await getCampaignById(id);

    const data = res.data;

    if (data.status !== "scheduled") {
      alert("Only scheduled campaigns can be edited.");
     
      return;
    }

    setCampaign(data);
    setName(data.name);
    setChannel(data.channel);
    setTargetType(data.targetType);
    setTargetId(data.targetId);
    setTemplateUseCase(data.templateUseCase);
    setScheduledAt(data.scheduledAt);
  }

  async function handleUpdate() {
    await updateCampaign(id, {currentToken,appToken,tenantId,
      name,
      channel,
      targetType,
      targetId,
      templateUseCase,
      scheduledAt
    });

    alert("Campaign updated");
    history.push(`campaigns/${id}`);
  }

  if (!campaign) return <p>Loading...</p>;

  return (
    <div style={{position:"relative",zIndex:99999}}>
      <h2>Edit Campaign</h2>

      <input
        value={name}
        onChange={e => setName(e.target.value)}
      />

      <CampaignChannelSelector
        value={channel}
        onChange={setChannel}
      />

      <CampaignTargetSelector
        targetType={targetType}
        setTargetType={setTargetType}
        setTargetId={setTargetId}
      />

      <input
        value={templateUseCase}
        onChange={e => setTemplateUseCase(e.target.value)}
        placeholder="Template Use Case"
      />

      <CampaignScheduleSelector
        scheduledAt={scheduledAt}
        setScheduledAt={setScheduledAt}
      />

      <button onClick={handleUpdate}>
        Update Campaign
      </button>
    </div>
  );
}
